"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M7 5H5c-.55 0-1-.45-1-1s.45-1 1-1h2V1c0-.55.45-1 1-1s1 .45 1 1v2h2c.55 0 1 .45 1 1s-.45 1-1 1H9v2c0 .55-.45 1-1 1s-1-.45-1-1V5zm7 9V8h-1V6h2.2a.8.8 0 01.8.8v8.4a.8.8 0 01-.8.8H.8a.8.8 0 01-.8-.8V6.8A.8.8 0 01.8 6H3v2H2v6h12z"];
//# sourceMappingURL=add-parent.js.map